import { render } from "./CommentsComponent.vue?vue&type=template&id=0fee1f9a"
import script from "./CommentsComponent.vue?vue&type=script&lang=js"
export * from "./CommentsComponent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\1402\\Back\\API_Core\\ApiCore\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__